import classNames from "classnames/bind";
import React from "react";
import { colours } from "../../constants/colours";
import { DataDisplayWithAdornment } from "../../DataDisplay/_components/DataDisplayWithAdornment";
import { Icon } from "../../Icon";
import { SequentialContentReveal } from "../../SequentialContentReveal/SequentialContentReveal";
import styles from "./RichTextDataDisplay.module.scss";
import type { RichTextDataDisplayProps } from "./types";

const cx = classNames.bind(styles);

const RichTextDataDisplay = ({
  value,
  isNextSizing = false,
  isContainerSizing = false,
  sequentialReveal = false,
  sequentialRevealSpeed = 250,
  alignment = "left",
  emptyContent = "",
  showInvalidIndicator = true,
  invalidText = "Unsupported data type",
  className,
  style,
  isInline = false,
  isBusy = false,
  isLoading = false,
  as: asProp,
}: RichTextDataDisplayProps) => {
  const isEmpty = value === null || value === "" || value === undefined;
  const isInvalid = value === null;
  const CustomNode = asProp ?? "div";

  return (
    <DataDisplayWithAdornment
      showAdornment={showInvalidIndicator && !isEmpty && isInvalid}
      alignment={alignment}
      isInline={isInline}
      isBusy={isBusy}
      isLoading={isLoading}
      adornmentSlot={({ iconProps, className }) => (
        <span className={className}>
          <Icon
            {...iconProps}
            variant="warning"
            colour={colours.status.warning}
            alt={invalidText}
            aria-roledescription="Warning Icon"
          />
        </span>
      )}
      className={cx(className, isInvalid && "bare")}
      style={{ ...(style ?? {}) }}
    >
      {isEmpty || isInvalid ? (
        emptyContent
      ) : (
        <CustomNode
          className={cx("container", {
            "is-next-sizing": isNextSizing,
            "is-container-sizing": isContainerSizing,
          })}
        >
          {sequentialReveal ? (
            <SequentialContentReveal delay={sequentialRevealSpeed}>
              {value}
            </SequentialContentReveal>
          ) : (
            value
          )}
        </CustomNode>
      )}
    </DataDisplayWithAdornment>
  );
};

export default RichTextDataDisplay;
